import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';

// components
import { LoadingScreen } from 'src/components/loading-screen';
import AccountPage from 'src/pages/dashboard/user/account';


const FaqPage = lazy(() => import('src/pages/main-dashboard/faq/faq-page'));
const TacPage = lazy(() => import('src/pages/main-dashboard/terms-and-conditions/tac-page'));
const AboutUsPage = lazy(() => import('src/pages/main-dashboard/about-us/about-us-page'));
const SupportPage = lazy(() => import('src/pages/main-dashboard/support/support-page'));
const PrivacyPolicyPage = lazy(() => import('src/pages/main-dashboard/privacy-policy/privacy-policy-page'));
const SettingPage = lazy(() => import('src/pages/general-setting'));
const DocsPage = lazy(() => import('src/pages/docs'));
// ----------------------------------------------------------------------



// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));


const JobsPage = lazy(() => import('src/pages/main-dashboard/jobs/jobs-page'));
const JobDetailPage = lazy(() => import('src/pages/main-dashboard/jobs/job-detail-page'));

//contractor
const ContractorPage = lazy(() => import('src/pages/main-dashboard/contractor/contractor-page'));
const ContractorDetailPage = lazy(() => import('src/pages/main-dashboard/contractor/contractor-detail-page'));

//clients
const Clients = lazy(() => import('src/pages/main-dashboard/clients/clients-page'));
const ClientDetailPage = lazy(() => import('src/pages/main-dashboard/clients/client-detail-page'));



//invoices
const InvoicesPage = lazy(() => import('src/pages/main-dashboard/invoices/invoices-page'));
const DetailsInvoicePage = lazy(() => import('src/pages/main-dashboard/invoices/detail-invoice-page'));

//job type
const JobTypeListPage = lazy(() => import('src/pages/main-dashboard/job-type/list'));
//jobs routes

const ContactUs = lazy(() => import('src/pages/main-dashboard/requests/contact-us'));
const ContactSupport = lazy(() => import('src/pages/main-dashboard/requests/contact-support'));

//estimator settings  
const GeographicAdjusterPage = lazy(() => import('src/pages/main-dashboard/estimator-settings/geographic-adjustor-page'));
const PrimaryServicePage = lazy(() => import('src/pages/main-dashboard/estimator-settings/primary-service-page'));
const AdditionalServicePage = lazy(() => import('src/pages/main-dashboard/estimator-settings/additional-service-page'));
const EstimatorTermsPage = lazy(() => import('src/pages/main-dashboard/estimator-settings/terms-and-conditions-page'));
const MetricPage = lazy(() => import('src/pages/main-dashboard/metric/metric-page'));
const InvoiceNotesPage = lazy(() => import('src/pages/main-dashboard/estimator-settings/invoice-notes-page'));
const EstimateNotesPage = lazy(() => import('src/pages/main-dashboard/estimator-settings/estimate-notes-page'));
const EstimateCategoriesPage = lazy(() => import('src/pages/main-dashboard/estimator-settings/estimate-categories-page'));

//technicians
const TechniciansPage = lazy(() => import('src/pages/main-dashboard/technicians/technicians-page'));
const TechnicianDetailPage = lazy(() => import('src/pages/main-dashboard/technicians/technician-detail-page'));
const CalendarPage = lazy(() => import('src/pages/dashboard/calendar'));

//estimator templates
const EstimatorTemplatePage = lazy(() => import('src/pages/main-dashboard/estimator-template/list'));
const CreateEstimatorTemplateView = lazy(() => import('src/pages/main-dashboard/estimator-template/add'));
const EstimatorTemplateProfilePage = lazy(() => import('src/pages/main-dashboard/estimator-template/profile'));

// Training Academy
const CategoryPage = lazy(() => import('src/pages/main-dashboard/training-academy/Categories'));
const CoursePage = lazy(() => import('src/pages/main-dashboard/training-academy/courses/list'));
const CreateCoursePage = lazy(() => import('src/pages/main-dashboard/training-academy/courses/add'));
const EditCoursePage = lazy(() => import('src/pages/main-dashboard/training-academy/courses/edit'));
const CourseDetailPage = lazy(() => import('src/pages/main-dashboard/training-academy/courses/detail'));
const CreateLessonPage = lazy(() => import('src/pages/main-dashboard/training-academy/courses/add-lesson'));
const EditLessonPage = lazy(() => import('src/pages/main-dashboard/training-academy/courses/edit-lesson'));
const LessonsListPage = lazy(() => import('src/pages/main-dashboard/training-academy/courses/lessons-list'));


// ----------------------------------------------------------------------
const CategoriesPage = lazy(() => import('src/pages/main-dashboard/support-center/categories/list'));
const ResourcePackagesPage = lazy(() => import('src/pages/main-dashboard/support-center/resource-packages/list'));
const ResourcePackageAssignResourcesPage = lazy(() => import('src/pages/main-dashboard/support-center/resource-packages/assign-resources'));
const ResourcePage = lazy(() => import('src/pages/main-dashboard/support-center/resources/list'));
const ResourceReorderPage = lazy(() => import('src/pages/main-dashboard/support-center/resources/reorder'));
const CreateResourcePage = lazy(() => import('src/pages/main-dashboard/support-center/resources/add'));
const EditResourcePage = lazy(() => import('src/pages/main-dashboard/support-center/resources/edit'));
const ResourceDetailView = lazy(() => import('src/sections/main-sections/support-center/resources/view/resource-detail-view'));
const UserPage = lazy(() => import('src/pages/main-dashboard/support-center/user/list'));
const UserAssignResourcesPage = lazy(() => import('src/pages/main-dashboard/support-center/user/assign-resources'));
const AlertsPage = lazy(() => import('src/pages/main-dashboard/training-academy/alerts/list'));
const CustomizePage = lazy(() => import('src/pages/main-dashboard/settings/customize-pages'));
const AddCustomizePage = lazy(() => import('src/pages/main-dashboard/settings/add-customize-page'));
const ReorderCoursesPage = lazy(() => import('src/pages/main-dashboard/training-academy/courses/reorder'));
const ReorderLessonsPage = lazy(() => import('src/pages/main-dashboard/training-academy/courses/reorder-lessons'));


//build mode 
const ActiveBuilds = lazy(() => import('src/pages/main-dashboard/build-mode/active-builds'));
const BuildDetailPage = lazy(() => import('src/pages/main-dashboard/build-mode/build-detail'));
const BuildStages = lazy(() => import('src/pages/main-dashboard/build-mode/build-stages'));
const ShopFloorDisplay = lazy(() => import('src/pages/main-dashboard/build-mode/shop-floor-display'));
const Notifications = lazy(() => import('src/pages/main-dashboard/build-mode/notifications'));
const ShopAdminsPage = lazy(() => import('src/pages/main-dashboard/build-mode/shop-admins'));
const MessageBoardPage = lazy(() => import('src/pages/main-dashboard/build-mode/messge-board'));
const ShopAdminDetailPage = lazy(() => import('src/pages/main-dashboard/build-mode/shop-admin-detail'));
const BuildNotificationPage = lazy(() => import('src/pages/main-dashboard/build-mode/shop-admin-notification'));
const AdminManagementPage = lazy(() => import('src/pages/main-dashboard/admin-management'));
const AiChatPage = lazy(() => import('src/pages/main-dashboard/ai-chat'));

export const superadmindashboardRoutes = [
  {
    path: 'admin',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { path: 'dashboard', element: <IndexPage /> },
      { path: 'ai-chat', element: <AiChatPage /> },
      { path: 'admin-management', element: <AdminManagementPage /> },
      {
        path: "contractor", children: [
          { element: <ContractorPage />, index: true },
          { path: ':id', element: <ContractorDetailPage /> }
        ]
      },
      {
        path: 'client', children: [
          { element: <Clients />, index: true },
          { path: ':id', element: <ClientDetailPage /> }
        ]
      },

      // { path: 'quote', element: <Quoteview /> },

      { path: 'metric', element: <MetricPage /> },

      {
        path: 'estimator-templates', children: [
          { element: <EstimatorTemplatePage />, index: true },
          { path: 'create', element: <CreateEstimatorTemplateView /> },
          { path: ':id', element: <EstimatorTemplateProfilePage /> }
        ]
      },
      {
        path: 'estimator-setting',
        children: [
          { element: <GeographicAdjusterPage />, index: true },

          { path: 'geographic-adjustor', element: <GeographicAdjusterPage /> },

          { path: 'primary-service', element: <PrimaryServicePage /> },

          { path: 'additional-service', element: <AdditionalServicePage /> },

          { path: 'terms', element: <EstimatorTermsPage /> },

          { path: 'metric', element: <MetricPage /> },

          { path: 'invoice-notes', element: <InvoiceNotesPage /> },

          { path: 'estimate-notes', element: <EstimateNotesPage /> },

          { path: 'categories', element: <EstimateCategoriesPage /> },

        ],
      },
      {
        path: 'invoices', children: [
          { element: <InvoicesPage />, index: true },
          { path: ':id', element: <DetailsInvoicePage /> }
        ]
      },
      {
        path: 'technicians', children: [
          { element: <TechniciansPage />, index: true },
          { path: ':id', element: <TechnicianDetailPage /> }
        ]
      },
      {
        path: 'jobs', children: [
          { element: <JobsPage />, index: true },
          { path: ':id', element: <JobDetailPage /> }
        ]
      },

      {
        path: 'job-type', children: [
          { element: <JobTypeListPage />, index: true },
        ]
      },
      { path: 'calendar', element: <CalendarPage /> },
      {
        path: 'requests', children: [
          { path: "contact-us", element: <ContactUs /> },
          { path: "contact-support", element: <ContactSupport /> }
        ]
      },
      {
        path: 'training-academy', children: [
          { path: "categories", element: <CategoryPage /> },
          { path: "alerts", element: <AlertsPage /> },
          { path: "courses", element: <CoursePage /> },
          { path: "course/add", element: <CreateCoursePage /> },
          { path: "course/edit/:id", element: <EditCoursePage /> },
          { path: "course/detail/:id", element: <CourseDetailPage /> },
          { path: 'course/:courseId/lesson/add', element: <CreateLessonPage /> },
          { path: 'course/:courseId/lesson/edit/:id', element: <EditLessonPage /> },
          { path: 'course/:courseId/lessons', element: <LessonsListPage /> },
          { path: 'courses/reorder', element: <ReorderCoursesPage /> },
          { path: 'course/:courseId/lessons/reorder', element: <ReorderLessonsPage /> },
        ]
      },
      {
        path: 'support-center', children: [
          { path: "categories", element: <CategoriesPage /> },
          { path: "resource-packages", element: <ResourcePackagesPage /> },
          { path: "resource-packages/:id/assign-resources", element: <ResourcePackageAssignResourcesPage /> },
          { path: "resources", element: <ResourcePage /> },
          { path: "resource/add", element: <CreateResourcePage /> },
          { path: "resource/:id/edit", element: <EditResourcePage /> },
          { path: "resource/:id/detail", element: <ResourceDetailView /> },
          { path: "resource/reorder", element: <ResourceReorderPage /> },
          { path: "user", element: <UserPage /> },
          { path: "user/:userId/assign-resources", element: <UserAssignResourcesPage /> },
          { path: "user/:userId/assign-resources/:packageId", element: <UserAssignResourcesPage /> },
          { path: "user/:userId/edit-resources", element: <UserAssignResourcesPage /> }
        ]
      },
      {
        path: "build-mode",
        children: [
          { path: "build-list", element: <ActiveBuilds /> },
          { path: "build-detail/:id", element: <BuildDetailPage /> },
          { path: "build-stages", element: <BuildStages /> },
          { path: "shop-admins", element: <ShopAdminsPage /> },
          { path: "shop-admin-detail/:id", element: <ShopAdminDetailPage /> },
          { path: "shop-floor-display", element: <ShopFloorDisplay /> },
          { path: "message-board", element: <MessageBoardPage /> },
          { path: "notifications", element: <Notifications /> },
          { path: "notifications/:id", element: <BuildNotificationPage /> }

        ]
      },
      { path: 'account', element: <AccountPage /> },
      { path: 'faqs', element: <FaqPage /> },
      { path: 'about-us', element: <AboutUsPage /> },
      { path: 'privacy', element: <PrivacyPolicyPage /> },
      { path: 'contact-support', element: <SupportPage /> },
      { path: 'terms', element: <TacPage /> },
      { path: 'docs', element: <DocsPage /> },
      {
        path: 'settings',
        children: [
          { path: 'general', element: <SettingPage />, index: true },
          { path: 'customize-pages', element: <CustomizePage /> },
          { path: 'customize-pages/add', element: <AddCustomizePage /> },
          { path: 'customize-pages/:slug/edit', element: <AddCustomizePage /> },
        ],
      },
    ],
  },
];
